import type {AppState} from "./AppState";

let registeredAppState: AppState | null = null;

export const registerAppState = (appState: AppState) => {
    registeredAppState = appState;
};

export const clearRegisteredAppState = () => {
    registeredAppState = null;
};

export const getRegisteredAppState = () => {
    return registeredAppState;
};
